import React from 'react';



export default function Deadlines(){

    return(
        <div className={'aboutContainer'}>
        <h1 className={"About-Header"}>PQE-2023 Deadlines</h1>
            <h2>Deadlines for complete conference registration</h2>
            <ul>
                <li>Abstracts are due November 10th</li>
                <li>Pre-payment is due December 25th</li>
            </ul>
            <h2>Hotel Information</h2>
            <p className={"About-Content"}>The Conference will be held at the cliff lodge at snowbird. Please also use the group code <b>PQE 123 </b> on the hotel reservation form. <br/>
            Please click the link below to reserve a room.
            </p>
            <a href={'https://reservations.snowbird.com/default.aspx?p=&group=PQE123&arrival=01/08/2023&depart=01/13/2023&bookingstep=1'}>Reserve a Room</a>

        </div>



    )


}